import React from "react";

import ServicesGrid from "../components/ServicesGrid";
import BlogList from "../components/BlogList";
import Testimonials from "../components/Testimonials";
import Footer from "../components/Footer";
import AltindagIntro from "../components/ServiceRegions/İntros/AltindagIntro";
import DynamicImage from "../components/DynamicImage";


const AltindagPage = () => {
  return (
    <> 
    <div>
        
      {/* <HeroSlider /> */}
      {/* <AboutSection/> */}
      <DynamicImage />
      <AltindagIntro/>
      <ServicesGrid />
      <BlogList/>
      <Testimonials/>
      <Footer/>
     
    </div>
     </>
  );
};

export default AltindagPage;
